import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { AlertIcon, ManageIcon } from '../../images/icons/WrapSvg';

class Index extends React.Component {
    render() {
        const { anchorEl, handleClose, handleChange, info, intl } = this.props;

        const disabledProcess =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '57') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo));
        const disabledManage =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '62' || f === '64' || f === '80' || f === '84' || f === '110' || f === '111') &&
              info.security.licencias.some((f) => ( f === '150' || f === '151' || f === '152' || f === '154' || f === '156' || f === '157') && f.activo ));
        return (
            <Menu
                id="recipe-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="popupFloatBottom"
            >
                {!disabledProcess &&
                    <MenuItem className={'popup_menuItem'} onClick={(event) => handleChange(event, 5)}>
                        <ListItemIcon className={'popup_icon'}>
                            <AlertIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'popup_primary c_bluish barlow_semibold_label' }}
                            inset
                            primary={intl.formatMessage({ id: 'warning_menu' })}
                        />
                    </MenuItem>
                }
                {!disabledManage &&
                    <MenuItem className={'popup_menuItem'} onClick={(event) => handleChange(event, 6)}>
                        <ListItemIcon className={'popup_icon'}>
                            <ManageIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'popup_primary c_bluish barlow_semibold_label' }}
                            inset
                            primary={intl.formatMessage({ id: 'manage_menu' })}
                        />
                    </MenuItem>
                }
            </Menu>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Index);



// WEBPACK FOOTER //
// ./src/components/navbar/Popup.js